import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import Dashboard from './Dashboard';
import AdminPanel from './AdminPanel';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/" element={<Dashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
